import React from "react";
import * as action from "../../lib/BLL";
class FooterMap extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() { }

  componentDidMount() { }

  render() {
    const { footerMap } = this.props;
    return (
      <div className="footer-map">
        <ul className="footer-map-content">
          {footerMap && Object.keys(footerMap).map(row => {
            return (
              <li className={row.includes('咨询热线') ? "footer-list-hotline" : ""}>
                <a href="javascript:;" className={row.includes('咨询热线') ? "hd" : "header"}>
                  <span className="">{row}</span>
                </a>
                {footerMap[row] && footerMap[row].map(child => {
                  let hasRightLink = child.rightTitle;
                  return (
                    hasRightLink ? <a>
                      <a target="_blank" href={child.leftLink}>{child.leftTitle}</a>
                      <em>/</em>
                      <a target="_blank" href={child.rightLink}>{child.rightTitle}</a>
                    </a> : <a target="_blank" href={child.leftLink}>
                      <span className="">{child.leftTitle}</span>
                    </a>
                  )
                })}
              </li>
            )
          })}
        </ul>
      </div>
    );
  }
}

export default FooterMap;



// WEBPACK FOOTER //
// ./common/components/Footer/FooterMap.js